<template>
    <div>
        <UiHeroCardLayoutHeader
            v-editable="blok"
            :blok="blok"
            class="ui-hero-card-layout-header"
        ></UiHeroCardLayoutHeader>
    </div>
</template>

<script setup lang="ts">
import type { IHeroCardLayoutHeader } from '@nuxt-monorepo/ui/types/components/HeroCardLayout/LayoutHeader';

defineProps<{ blok: IHeroCardLayoutHeader }>();
</script>

<style lang="postcss" scoped>
:deep(.ui-hero-card-layout-header) {
    @apply px-5 sm:px-0 py-6 lg:py-14;
    &:has(.tabbed-searchbox-hero--sps-airport-page) {
        @apply md:pb-6 overflow-visible z-40;
    }

    .hero-image {
        @apply min-h-0;
    }
}
</style>
